import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export interface PageSizeSelectProps {
  value: number;
  options: readonly number[];
  onChange: (value: number) => void;
  testId?: string;
  className?: string;
}

/** Compact native "rows per page" select for list / table footers. */
export const PageSizeSelect: React.FC<PageSizeSelectProps> = ({
  value,
  options,
  onChange,
  testId,
  className,
}) => {
  const { t } = useTranslation('common');
  const selectId = useId();

  return (
    <span className={[styles.wrapper, className].filter(Boolean).join(' ')}>
      <label htmlFor={selectId} className={styles.label}>{t('common:rowsPerPage')}</label>
      <select
        id={selectId}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className={styles.select}
        data-testid={testId}
      >
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </span>
  );
};

export default PageSizeSelect;
